import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=7781e5da"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports